(function ($) {
	/******************************************
	 ** Responsive Old Version (MediaPlayer) **
	 ******************************************/
	
	function responVideo(elementSelect,filetype,filepath){
		switch(filetype){
		case 'mp4':
		case 'm4v':
		case 'webm':
		case 'ogg':
		case 'ogv':
			embedCode = '<video id="v" controls>'
			+'<source src="'+filepath+'" type="video/'+filetype+'">'
			+'Your browser does not support HTML5 video.</video>';
			elementSelect.before(embedCode);
			elementSelect.remove();
			break;
		case 'flv':	
			embedCode = '<object type="application/x-shockwave-flash" data="'+ parent.wex.url.baseUrl +'live/rvwysplayer.swf" width="420" height="344">';
			embedCode += '<param name="movie" value="'+ parent.wex.url.baseUrl + 'live/rvwysplayer.swf" />';
			embedCode += '<param name="wmode" value="transparent" />';
			embedCode += '<param name="bgcolor" value="#FFFFFF" />';
			embedCode += '<param name="quality" value="high" />';
			embedCode += '<param name="allowFullScreen" value="true" />';
			embedCode += '<param name="allowscriptaccess" value="always" />';
			embedCode += '<a href="http://www.adobe.com/go/getflash">';
			embedCode += '<img src="http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif" alt="Get Adobe Flash player"/>';
			embedCode += '</a>';
			embedCode += '<param name="flashvars" value="vdo='+filepath+'&amp;autoplay=false" />';
			embedCode += '</object>';
			elementSelect.before(embedCode);
			elementSelect.remove();
			break;
		case 'mov':
			embedCode = '<object classid="clsid:02BF25D5-8C17-4B23-BC80-D3488ABDDC6B" width="auto" height="auto" codebase="http://www.apple.com/qtactivex/qtplugin.cab">';
			embedCode += '<embed src="'+filepath+'" width="auto" height="auto"'+
				'scale="tofit" autoplay="false"'+
				'controller="true" loop="false" bgcolor="#000000"'+
				'pluginspage=\'http://www.apple.com/quicktime/download/\'>';
			embedCode += '</embed>';
			embedCode += '</object>';
			elementSelect.before(embedCode);
			elementSelect.remove();
		break;
		}
	}	
	$(document).on('editorReady',function(){
		var fBody = $('#frameBody').contents();
		fBody.find('object[id^=flvp][name^=flvp]').each(function(){
			var typeOfFile = $(this).children('param[name="flashvars"]').attr('value');
			if(typeOfFile){
				var pathVideoFile = typeOfFile.match(/file=.*\.(mp4|m4v|mov|flv|webm|ogg|ogv)/gi);
				pathVideoFile = pathVideoFile.toString().replace(/file=/,'');
				var matchTypeFile = typeOfFile.match(/(mp4|m4v|mov|flv|webm|ogg|ogv)/gi);
				responVideo($(this),matchTypeFile[matchTypeFile.length - 1],pathVideoFile);
			}
		});
		fBody.find('object[classid^=clsid][height!=auto][codebase][title]').each(function(){
			var typeOfFile = $(this).children('param[name="src"]').attr('value');
			if(typeOfFile){
				var pathVideoFile = typeOfFile.match(/.*\.(mp4|m4v|mov|flv|webm|ogg|ogv)/gi);
				var matchTypeFile = typeOfFile.match(/(mp4|m4v|mov|flv|webm|ogg|ogv)/gi);
				responVideo($(this),matchTypeFile[matchTypeFile.length - 1],pathVideoFile);
			}
		});

	});
}) (jQuery);
